const getters = {
  appToolbarTitle: (state) => state.appToolbarTitle || state.appDefaultTitle,
  userLanguage: (state, getters) => state.userSelectedLang || getters.defaultLanguage,
  defaultLanguage: (state) => {
    const langCodeLocale = (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      navigator.userLanguage

    const langCode = langCodeLocale.split('-')[0]

    let computedDefaultLang = state.appDefaultLang

    state.availableLangs.forEach(lang => {
      if (lang.code === langCodeLocale || lang.code === langCode) {
        computedDefaultLang = lang.code
      }
    })

    return computedDefaultLang
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js